import { useDispatch } from 'react-redux';
import { getPurchaseButtonInfoForEPGTransactions } from './../../../../../action-creators/payway/purchaseButtonInfo';
import { showEpgTransactions } from '../../../../Player/actions/epgTransactions/epgTransactions.actions';

export const useTransaction = () => {
  const dispatch = useDispatch();

  const openTransaction = ({ groupId, groupData }) => {
    dispatch(getPurchaseButtonInfoForEPGTransactions({ group_id: groupId }));
    dispatch(showEpgTransactions(groupData));
  };

  return { openTransaction };
};
